<template>
  <div class="validation_request_customer_container" :class="{ 'detailed-view': isDetails }">
    <h4>Client<slot name="title_suffix"></slot></h4>
    
    <div class="validation_request_customer_body_container">
      <div class="validation_request_customer_description">
        <h5>Informations</h5>

        <p>
          <router-link 
            :to="{ name: 'customer', params: { id: customer.id } }" 
            style="font-size: 16px; color:#fb557a;"
          >
            {{getEnumTranslatedValue('civility', customer.attributes.civility)}} {{customer.attributes.name}}
          </router-link>
        </p>

        <ul class="validation_request_customer_description_list">
          <li>Groupe : {{getEnumTranslatedValue('legal_form_group', customer.attributes.legal_form_group)}}</li>
          <li>Forme juridique : {{getEnumTranslatedValue('legal_form', customer.attributes.legal_form)}}</li>
          <li v-if="customer.attributes.decoded_origin">Origine : {{customer.attributes.decoded_origin}}</li>
          <li v-if="customer.attributes.siret">SIRET : {{customer.attributes.siret}}</li>
          <li v-if="customer.attributes.naf">NAF : {{customer.attributes.naf}}</li>
          <li v-if="customer.attributes.trade_name">Nom commercial : {{customer.attributes.trade_name}}</li>
          <li v-if="customer.attributes.initials">Initiales : {{customer.attributes.initials}}</li>
          <li>Statut : {{getEnumTranslatedValue('customer_status', customer.attributes.status)}}</li>
          <li>Statut vigilance : {{getEnumTranslatedValue('customer_vigilance_status', customer.attributes.vigilance_status)}}</li>
          <li v-if="customer.attributes.electronic_invoice">Facturation éléctronique</li>
          <li v-if="customer.attributes.postal_proxy">Procuration postale</li>
          <li>Activité : {{customer.attributes.activity}}</li>
          <li>
            <span>Emploie des salariés :</span>
            <span v-if="!customer.attributes.without_employee">Oui</span>
            <span v-else>Non</span>
          </li>
          <li v-if="customer.attributes.comments">
            <p style="margin-bottom: 0;">Commentaires :</p>
            <p style="background-color: #eaeaea; padding: 10px;">{{customer.attributes.comments}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ValidationRequestableCustomer",
    props: ["customer", "isDetails"]
  }
</script>

<style scoped>
.validation_request_customer_container {
  padding: 0 15px;
  width: 100%;
  background-color: white;
}

.validation_request_customer_description {
  padding: 0 15px;
  border: solid 1px lightgray;
  background-color: white;
}

.validation_request_customer_description > h5 {
  border-bottom: 1px solid lightgray;
  padding-bottom: 5px;
}

.head a {
  display: inline-block;
}

.head button {
  display: inline-block;
}

.detailed-view {
  border-color: lightgrey;
  border-style: solid;
  border-width: 1px 1px 0;
}

@media screen and (max-width: 800px) {
  .validation_request_customer_container {
    margin: 0;
    margin-bottom: 15px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/CustomerV2.vue